import { mainApi } from '../../../api/mainApi';
import { AccessState } from '../../../types';
import { middlewareApi } from '../../middleware/middlewareApi';
import { BillingData, DebtorPerson } from '../interfaces/debtorPerson.interfaces';

export const debtorPersonTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['PersonDebtor', 'PersonBillingData'],
});
// Define a service using a base URL and expected endpoints
export const debtorPersonApi = debtorPersonTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET get debtor by person id
     * @Permission debtors-obtener-deudor-persona
     */
    getDebtorByPersonId: builder.query<
      DebtorPerson,
      {
        profileId?: number;
        personId: number;
      }
    >({
      queryFn: async ({ profileId, personId }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.get<DebtorPerson>(`/debtors/person/${personId}`, {
            params: {
              ...(profileId ? { user_profile_id: profileId } : { user_profile_id }),
            },
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error, { personId }) => [{ type: 'PersonDebtor', personId }],
    }),

    /**
     * @GET person billing data
     * @Permission financial-information-obtener-id-debtor
     */
    getPersonBillingData: builder.query<BillingData, { debtorId: number }>({
      queryFn: async ({ debtorId }, { getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.get<BillingData>(
            `/financial-informations/debtor/${debtorId}`,
            {
              params: {
                user_profile_id,
              },
            }
          );

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error, { debtorId }) => [{ type: 'PersonBillingData', debtorId }],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDebtorByPersonIdQuery, useGetPersonBillingDataQuery } = debtorPersonApi;
